module.exports = __webpack_public_path__ + "static/media/HRBingo2.a196a5f6.png";